/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AdminUserMemo model module.
 * @module model/AdminUserMemo
 * @version 1.0.0
 */
class AdminUserMemo {
    /**
     * Constructs a new <code>AdminUserMemo</code>.
     * @alias module:model/AdminUserMemo
     */
    constructor() { 
        
        AdminUserMemo.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AdminUserMemo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AdminUserMemo} obj Optional instance to populate.
     * @return {module:model/AdminUserMemo} The populated <code>AdminUserMemo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AdminUserMemo();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('admin_user_id')) {
                obj['admin_user_id'] = ApiClient.convertToType(data['admin_user_id'], 'Number');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('memo')) {
                obj['memo'] = ApiClient.convertToType(data['memo'], 'String');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AdminUserMemo</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AdminUserMemo</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['memo'] && !(typeof data['memo'] === 'string' || data['memo'] instanceof String)) {
            throw new Error("Expected the field `memo` to be a primitive type in the JSON string but got " + data['memo']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AdminUserMemo.prototype['id'] = undefined;

/**
 * @member {Number} admin_user_id
 */
AdminUserMemo.prototype['admin_user_id'] = undefined;

/**
 * @member {Number} user_id
 */
AdminUserMemo.prototype['user_id'] = undefined;

/**
 * @member {String} memo
 */
AdminUserMemo.prototype['memo'] = undefined;

/**
 * @member {Date} created_at
 */
AdminUserMemo.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
AdminUserMemo.prototype['updated_at'] = undefined;






export default AdminUserMemo;

